"use strict";
import { useMemo } from "react";
import { useEnabledChains } from "features/chains/hooks/useEnabledChains";
import { UniverseChainId } from "features/chains/types";
import { getDexTokenList } from "constants/topazTokenList";
import { isAddress } from "utilities/src/addresses";
function tokenToGqlToken(token, chainId) {
  return {
    id: `${chainId}-${token.address}`,
    address: token.address,
    chain: chainId === UniverseChainId.Mainnet ? "ETHEREUM" : "SEPOLIA",
    symbol: token.symbol || "",
    name: token.name || "",
    decimals: token.decimals
  };
}
export function useSearchTokensGql(searchQuery = "") {
  const { chains } = useEnabledChains();
  return useMemo(() => {
    if (!searchQuery) {
      return { data: [], loading: false, error: void 0 };
    }
    const query = searchQuery.toLowerCase();
    const isSearchQueryAnAddress = isAddress(searchQuery);
    const results = [];
    chains.forEach((chainId) => {
      const chainTokens = getDexTokenList(chainId);
      const matchingTokens = chainTokens.filter((token) => {
        if (isSearchQueryAnAddress) {
          return token.address.toLowerCase() === query;
        }
        return token.symbol?.toLowerCase().includes(query) || token.name?.toLowerCase().includes(query);
      });
      const gqlTokens = matchingTokens.map((token) => tokenToGqlToken(token, chainId));
      results.push(...gqlTokens);
    });
    const sortedTokens = results.sort((a, b) => {
      const aSymbol = a.symbol.toLowerCase();
      const bSymbol = b.symbol.toLowerCase();
      const aExactMatch = aSymbol === query;
      const bExactMatch = bSymbol === query;
      if (aExactMatch && !bExactMatch) return -1;
      if (!aExactMatch && bExactMatch) return 1;
      return aSymbol.localeCompare(bSymbol);
    });
    return { data: sortedTokens, loading: false, error: void 0 };
  }, [searchQuery, chains]);
}
